import { getConversationDetails } from '@/services/api';
import { useQuery } from 'react-query';

interface UseGetConversationDetailsParams {
    conversationId: string | null;
    isPublic?: boolean;
    shareId?: string;
}

export const useGetConversationDetails = ({ conversationId, isPublic = false, shareId }: UseGetConversationDetailsParams) => {
    return useQuery({
        queryKey: ['conversation-details', conversationId, isPublic, shareId],
        queryFn: () => getConversationDetails(conversationId as string, isPublic, shareId),
        enabled: !!conversationId,
    });
};
